import { render, staticRenderFns } from "./CouponUsersDetail.vue?vue&type=template&id=17212d22"
import script from "./CouponUsersDetail.vue?vue&type=script&lang=js"
export * from "./CouponUsersDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports